import React from "react";
import type { IUploadCodeAndSourceSelectionStore } from "./UploadCodeAndSourceSelectionStore";
import { injectFromAppUpload } from "../../inject";
import { observer } from "mobx-react";
import { injectFromApp } from "../../../shared-components/inject";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import Select from "react-dropdown-select";
import type { IUploadStore } from "../../UploadStore";
import type { ICurrentUploadSettingsStore } from "../../CurrentUploadSettingsStore";
import { SourceLogoComponent } from "../../../shared-components/source-logo/SourceLogoComponent";

interface IUploadCodeAndSourceSelectionValidatedComponentProps {
    uploadCodeAndSourceSelectionStore?: IUploadCodeAndSourceSelectionStore;
    uploadStore?: IUploadStore;
    resourcesStore?: IResourcesStore;
    currentUploadSettingsStore?: ICurrentUploadSettingsStore;
}

@injectFromAppUpload<IUploadCodeAndSourceSelectionValidatedComponentProps>((stores) => ({
    uploadCodeAndSourceSelectionStore: stores.uploadCodeAndSourceSelectionStore,
    uploadStore: stores.uploadStore,
    currentUploadSettingsStore: stores.currentUploadSettingsStore,
}))

@injectFromApp<IUploadCodeAndSourceSelectionValidatedComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@observer
export class UploadCodeAndSourceSelectionValidatedComponent extends React.Component<IUploadCodeAndSourceSelectionValidatedComponentProps> {
    private readonly sourceChanged = (selectedOptions) => {
        const { uploadCodeAndSourceSelectionStore } = this.props;
        uploadCodeAndSourceSelectionStore!.setSelectedSource(!selectedOptions || selectedOptions.length === 0 ? null : selectedOptions[0]);
    };

    render() {
        const { uploadCodeAndSourceSelectionStore, resourcesStore, uploadStore, currentUploadSettingsStore } = this.props;
        const { selectedSourceForUpload, uploadCodeAndSourceValid, sourcesAvailableForUpload } = uploadCodeAndSourceSelectionStore!;
        const { resources } = resourcesStore!;
        const { patientsFound } = uploadStore!;
        const { userUploadsWithoutCode } = currentUploadSettingsStore!;

        if (!uploadCodeAndSourceValid || !selectedSourceForUpload) return;

        return (
            <div className={"validated-upload-code-and-source"}>
                <div className={"header"}>
                    <h3>
                        {resources.UploadPortal}
                        {userUploadsWithoutCode && sourcesAvailableForUpload.length > 1 ? (
                            <Select
                                values={selectedSourceForUpload ? [selectedSourceForUpload] : []}
                                onChange={this.sourceChanged}
                                multi={false}
                                options={sourcesAvailableForUpload}
                                placeholder={resources.SelectHospitalToUpload}
                                labelField={"description"}
                                valueField={"id"}
                                searchBy={"description"}
                                clearable={false}
                                dropdownGap={1}
                                autoFocus={false}
                                noDataLabel={resources.NoResultsFound}
                                backspaceDelete={false}
                                disabled={patientsFound.length > 0}
                                className={patientsFound.length > 0 ? "disabled" : ""}
                            />
                        ) : (
                            <span>{selectedSourceForUpload.description}</span>
                        )}
                    </h3>

                    <div className={"info"}>
                        {selectedSourceForUpload?.telephone && <div className={"telephone"}>{selectedSourceForUpload.telephone}</div>}
                        {selectedSourceForUpload?.email && <div className={"email"}>{selectedSourceForUpload.email}</div>}
                        <a className={"manual"} href={"/POW3/Resource/LocalHelpFile?manualsSection=Upload"} target="_blank" rel="noreferrer">
                            {resources.UploadManual}
                        </a>
                    </div>
                </div>
                <div className={"logo"}>
                    {selectedSourceForUpload?.logo && (
                        <SourceLogoComponent logo={ selectedSourceForUpload.logo } logoStyle={ selectedSourceForUpload.logoStyle } description={ selectedSourceForUpload.description } />
                    )}
                </div>
            </div>
        );
    }
}
